<template>
  <div>
    <PageHeader :line="false">
      <el-input
        size="mini"
        prefix-icon="el-icon-search"
        placeholder="Search"
        v-model="searchVal"
        v-debounce="onSearch"
        clearable
        @clear="onSearch"
      />
    </PageHeader>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="Loading..."
      ref="table"
      @sort-change="onSortChange"
    >
      <el-table-column label="No." width="115" prop="No" sortable="custom" />
      <el-table-column
        label="Push Type"
        width="130"
        prop="PushType"
        sortable="custom"
      />
      <el-table-column
        label="Document Title"
        min-width="150"
        prop="DocumentTitle"
        sortable="custom"
      />
      <el-table-column
        label="Comment"
        min-width="150"
        prop="Comment"
        sortable="custom"
      />
      <el-table-column
        label="Commented On"
        width="170"
        prop="CommentedOn"
        sortable="custom"
      />
    </el-table>
    <div class="pagination-wrap">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PushedContent',
  data() {
    return {
      tableLoading: true,
      searchVal: '',
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: 'CommentedOn',
      orderType: 'descending',
    }
  },
  computed: {
    params() {
      return this.$route.params
    },
  },
  created() {
    this.getTableData()
  },
  methods: {
    onSearch() {
      this.currentPage = 1
      this.getTableData()
    },
    onSortChange(column) {
      this.orderBy = column.prop
      this.orderType = column.order
      this.getTableData()
    },
    getTableData() {
      this.tableLoading = true
      let params = {
        ...this.params,
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      }
      this.axios
        .get(`/seDetail/viewComment`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data
            this.total = data.total
          } else {
            this.$message({
              type: 'error',
              message: msg,
            })
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getTableData()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.getTableData()
    },
  },
}
</script>

<style lang="scss" scoped></style>
